const momentDateToBUDateStringUtils = {
  hk: (momentDate) => {
    return momentDate
    .utcOffset(0, false)
    .set({ hour: 0, minute: 0, second: 0, millisecond: 0 })
    .format("x"); // Unix Millisecond Timestamp
  },
  th: (momentDate) => {
    return momentDate.format("YYYYMMDD");
  },
  my: (momentDate) => {
    return momentDate.format("YYYYMMDD");
  },
  vn: (momentDate) => {
    return ''; // TBC
  },
  id: (momentDate) => {
    return ''; // TBC
  },
}

const momentDateToYearString = (momentDate) => {
  return momentDate.format('YYYY');
}

export {
  momentDateToBUDateStringUtils,
  momentDateToYearString,
};
